/**
 * specialties.js — the one list of specialties.
 *
 * Extracted from Onboarding.jsx because Settings now needs the same list. Two
 * copies would drift the first time one is edited, and the failure would be
 * quiet: a specialty offered at signup but missing from Settings, so a user
 * could hold a value they can see but never reselect.
 *
 * Order is deliberate. Students come first because Clincordant's earliest users are
 * students, and burying "Medical Student" under twenty consultant specialties
 * makes them feel like an afterthought on the first screen they ever see.
 *
 * This list is a convenience, not a constraint — users may type their own, and
 * those are stored alongside these. Adding an entry here is safe; removing one
 * is not, because existing profiles may already hold it.
 */

export const SPECIALTIES = [
  'Medical Student', 'Nursing Student', 'Other Healthcare Student',
  'Primary Care', 'Internal Medicine', 'Geriatrics', 'Cardiology', 'Respiratory',
  'Infectious Disease', 'Psychiatry', 'Oncology', 'Neurology', 'Emergency Medicine',
  'Paediatrics', 'Obstetrics & Gynaecology', 'Radiology', 'Surgery', 'Anaesthetics',
  'Endocrinology', 'Gastroenterology', 'Nephrology', 'Rheumatology', 'Dermatology',
  'Palliative Care', 'Public Health', 'Nursing', 'Pharmacy', 'Allied Health', 'Research',
];

/**
 * Hard caps, matching firestore.rules exactly.
 *
 * The rule rejects the whole write if either is exceeded, so the UI must stop
 * the user before they get there — a save button that fails with no explanation
 * is worse than a disabled chip.
 */
export const MAX_SPECIALTIES = 8;
export const MAX_CUSTOM_SPECIALTIES = 5;

/** Case-insensitive membership test, so "cardiology" matches "Cardiology". */
export function findSpecialty(list, value) {
  const needle = String(value || '').trim().toLowerCase();
  if (!needle) return null;
  return list.find((s) => s.toLowerCase() === needle) ?? null;
}
